package com.eladfinish.bible.contest.screens.pyramidCrossword.ui

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.LazyListScope
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.automirrored.filled.ArrowForward
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberUpdatedState
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.input.key.key
import androidx.compose.ui.input.key.onPreviewKeyEvent
import androidx.compose.ui.input.key.type
import androidx.compose.ui.platform.LocalFocusManager
import androidx.compose.ui.platform.LocalSoftwareKeyboardController
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.TextRange
import androidx.compose.ui.text.buildAnnotatedString
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.TextFieldValue
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.correct_answer_bell_gliss_mp3
import com.eladfinish.bible.contest.extensions.convertToDataClass
import com.eladfinish.bible.contest.ic_answer_correct
import com.eladfinish.bible.contest.ic_answer_wrong
import com.eladfinish.bible.contest.key_backspace_pressed_mp3
import com.eladfinish.bible.contest.little_rainy_seasons_correct_mp3
import com.eladfinish.bible.contest.navigation.PyramidScreenNavigationDestination
import com.eladfinish.bible.contest.navigation.screenKey
import com.eladfinish.bible.contest.next_pyramid
import com.eladfinish.bible.contest.page_turning_mp3
import com.eladfinish.bible.contest.platform.audio.SoundService
import com.eladfinish.bible.contest.platform.haptics.HapticService
import com.eladfinish.bible.contest.screens.pyramidCrossword.PyramidCrosswordAction
import com.eladfinish.bible.contest.screens.pyramidCrossword.PyramidCrosswordEffect
import com.eladfinish.bible.contest.screens.pyramidCrossword.PyramidCrosswordState
import com.eladfinish.bible.contest.screens.pyramidCrossword.PyramidCrosswordState.DialogState
import com.eladfinish.bible.contest.screens.pyramidCrossword.PyramidCrosswordStore
import com.eladfinish.bible.contest.screens.pyramidCrossword.model.PyramidQuestion
import com.eladfinish.bible.contest.screens.pyramidCrossword.ui.dialogs.PyramidCrosswordDialogs
import com.eladfinish.bible.contest.ui.common.PreviewTheme
import com.eladfinish.bible.contest.ui.common.accentColor
import com.eladfinish.bible.contest.ui.components.buttons.ItemButtonText
import com.eladfinish.bible.contest.ui.components.mouseVerticalScrollbar
import com.eladfinish.bible.contest.ui.extensions.navigationBarContentPadding
import com.eladfinish.bible.contest.ui.layout.isKeyboardOpen
import com.eladfinish.bible.contest.ui.layout.isShortWideWindow
import com.eladfinish.bible.contest.ui.layout.readableWidth
import com.eladfinish.bible.contest.ui.menus.actions.PyramidCrosswordToolbarAction
import com.eladfinish.bible.contest.ui.menus.viewModels.ToolbarActionBusViewModel
import com.eladfinish.bible.contest.ui.modifiers.dismissKeyboardOnTap
import com.eladfinish.bible.contest.ui.text.applyUnderscorePlaceholders
import com.eladfinish.bible.contest.ui.text.toAnnotatedWithUnderscorePlaceholders
import com.eladfinish.bible.contest.utils.isPreview
import dev.icerock.moko.resources.compose.painterResource
import dev.icerock.moko.resources.compose.stringResource
import kotlinx.collections.immutable.toImmutableList
import kotlinx.coroutines.flow.collectLatest
import org.koin.compose.koinInject
import org.koin.compose.viewmodel.koinViewModel

@Composable
fun PyramidCrosswordScreen(
    store: PyramidCrosswordStore = koinViewModel(),
    toolbarActionBus: ToolbarActionBusViewModel,
    showToast: (String) -> Unit,
) {
    val state by store.observeState().collectAsState()
    val soundService: SoundService = koinInject()
    val hapticService: HapticService = koinInject()
    val currentShowToast by rememberUpdatedState(showToast)
    val keyboardController = LocalSoftwareKeyboardController.current
    val currentLocalFocus = LocalFocusManager.current

    PyramidCrosswordToolbarBindings(
        onAction = store::dispatch,
        toolbarActionBus = toolbarActionBus,
    )

    LaunchedEffect(Unit) {
        store.observeSideEffect().collectLatest { effect ->
            when (effect) {
                PyramidCrosswordEffect.PlayCorrectSound -> soundService.playIfAllowed(SharedRes.files.little_rainy_seasons_correct_mp3)
                PyramidCrosswordEffect.PlayIncorrectSound -> {} // Add sound if needed
                PyramidCrosswordEffect.PlayPageTurningSound -> soundService.playIfAllowed(SharedRes.files.page_turning_mp3)
                PyramidCrosswordEffect.PlayBackspaceSound -> soundService.playIfAllowed(SharedRes.files.key_backspace_pressed_mp3)
                PyramidCrosswordEffect.VibrateLong -> hapticService.vibrateIfAllowed(milliseconds = 150)
                PyramidCrosswordEffect.VibrateShort -> hapticService.vibrateIfAllowed(milliseconds = 50)
                is PyramidCrosswordEffect.ShowToast -> {
                    currentShowToast(effect.message)
                }

                is PyramidCrosswordEffect.GameCompleted -> {
                    currentLocalFocus.clearFocus()
                    keyboardController?.hide()

                    soundService.playIfAllowed(
                        SharedRes.files.correct_answer_bell_gliss_mp3,
                    )

                    currentShowToast(effect.toastMessage)
                }
            }
        }
    }

    PyramidCrosswordContent(
        state = state,
        onAction = store::dispatch,
        onInvalidInput = { hapticService.vibrateIfAllowed(milliseconds = 80) },
    )

    PyramidCrosswordDialogs(
        dialogState = state.dialogState,
        onAction = store::dispatch
    )
}

@Composable
private fun PyramidCrosswordToolbarBindings(
    onAction: (PyramidCrosswordAction) -> Unit,
    toolbarActionBus: ToolbarActionBusViewModel,
) {
    val screenKey = PyramidScreenNavigationDestination::class.screenKey

    val onDispatch by rememberUpdatedState<(PyramidCrosswordToolbarAction) -> Unit> { action ->
        onAction(PyramidCrosswordAction.ToolbarClicked(toolbarAction = action))
    }

    LaunchedEffect(screenKey) {
        toolbarActionBus.setActiveScreenKey(screenKey)
        toolbarActionBus.events.collect { event ->
            if (event.screenKey != screenKey) return@collect
            val action = event.action as? PyramidCrosswordToolbarAction ?: return@collect
            onDispatch(action)
        }
    }
}

@Composable
private fun PyramidCrosswordContent(
    state: PyramidCrosswordState,
    onAction: (PyramidCrosswordAction) -> Unit,
    onInvalidInput: () -> Unit,
) {
    if (state.isLoading) {
        Box(Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
            CircularProgressIndicator()
        }
        return
    }

    val keyboardController = LocalSoftwareKeyboardController.current

    Box(
        modifier = Modifier
            .fillMaxSize()
            .dismissKeyboardOnTap(
                keyboardController = keyboardController,
            ),
    ) {
        val listState = rememberLazyListState()

        if (isShortWideWindow()) {
            // The clues beside the pyramid, under a title that stays: the keyboard leaves room for a row or two.
            Column(modifier = Modifier.fillMaxSize()) {
                Box(modifier = Modifier.padding(horizontal = 16.dp, vertical = 4.dp)) {
                    PyramidTitle(state, onAction)
                }
                Row(modifier = Modifier.fillMaxSize()) {
                    LazyColumn(
                        state = listState,
                        modifier = Modifier
                            .weight(1f)
                            .fillMaxHeight()
                            .mouseVerticalScrollbar(listState),
                        contentPadding = navigationBarContentPadding(horizontal = 16.dp, top = 4.dp, bottom = 16.dp),
                        horizontalAlignment = Alignment.CenterHorizontally,
                        verticalArrangement = Arrangement.spacedBy(12.dp),
                    ) {
                        pyramidRows(state, onAction, onInvalidInput)

                        item {
                            BottomControls(onAction)
                        }
                    }
                    val cluesListState = rememberLazyListState()
                    LazyColumn(
                        state = cluesListState,
                        modifier = Modifier
                            .weight(1f)
                            .fillMaxHeight()
                            .mouseVerticalScrollbar(cluesListState),
                        contentPadding = navigationBarContentPadding(horizontal = 16.dp, top = 4.dp, bottom = 16.dp),
                    ) {
                        item {
                            QuestionsSection(state, onAction)
                        }
                    }
                }
            }
            return@Box
        }

        LazyColumn(
            state = listState,
            modifier = Modifier
                .readableWidth()
                .fillMaxSize()
                .mouseVerticalScrollbar(listState),
            contentPadding = navigationBarContentPadding(horizontal = 16.dp, top = 16.dp, bottom = 16.dp),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(12.dp),
        ) {
            item {
                PyramidTitle(state, onAction)
            }

            pyramidRows(state, onAction, onInvalidInput)

            item {
                QuestionsSection(state, onAction)
            }

            item {
                BottomControls(onAction)
            }

            item {
                Spacer(modifier = Modifier.height(96.dp))
            }
        }
    }
}

@Composable
private fun PyramidTitle(
    state: PyramidCrosswordState,
    onAction: (PyramidCrosswordAction) -> Unit,
) {
    val currentQuestion = state.currentQuestions.getOrNull(state.focusedRowIndex)
    val title = currentQuestion?.question.orEmpty()

    Row(
        modifier = Modifier.fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        IconButton(
            onClick = { onAction(PyramidCrosswordAction.OnPrevRow) },
        ) {
            Icon(Icons.AutoMirrored.Filled.ArrowBack, contentDescription = "Previous")
        }

        Text(
            text = title.toAnnotatedWithUnderscorePlaceholders(),
            style = MaterialTheme.typography.headlineSmall.copy(
                fontWeight = FontWeight.Bold
            ),
            textAlign = TextAlign.Center,
            modifier = Modifier.weight(1f)
        )

        IconButton(
            onClick = { onAction(PyramidCrosswordAction.OnNextRow) },
        ) {
            Icon(Icons.AutoMirrored.Filled.ArrowForward, contentDescription = "Next")
        }
    }
}


private fun LazyListScope.pyramidRows(
    state: PyramidCrosswordState,
    onAction: (PyramidCrosswordAction) -> Unit,
    onInvalidInput: () -> Unit,

    ) {
    itemsIndexed(state.currentQuestions) { rowIndex, question ->
        PyramidRow(
            rowIndex = rowIndex,
            question = question,
            userAnswer = state.userAnswers[rowIndex].orEmpty(),
            isCorrect = state.rowValidation[rowIndex],
            isFocusedRow = rowIndex == state.focusedRowIndex,
            isGameFinished = state.isGameFinished,
            focusedCellIndex = state.focusedCellIndex,
            onAction = onAction,
            onInvalidInput = onInvalidInput,
        )
    }
}

@Composable
private fun QuestionsSection(
    state: PyramidCrosswordState,
    onAction: (PyramidCrosswordAction) -> Unit,
) {
    Column(
        modifier = Modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(4.dp)
    ) {
        state.currentQuestions.forEachIndexed { index, question ->
            val isSelected = index == state.focusedRowIndex
            val text = "${index + 1}. ${question.question}"

            Text(
                text = buildAnnotatedString {
                    applyUnderscorePlaceholders(
                        sourceText = text,
                        outerStyle = SpanStyle(
                            background = if (isSelected) Color.Yellow.copy(alpha = 0.3f) else Color.Transparent,
                            fontWeight = if (isSelected) FontWeight.Bold else FontWeight.Normal,
                        ),
                    )
                },
                modifier = Modifier
                    .fillMaxWidth()
                    .clickable {
                        onAction(
                            PyramidCrosswordAction.OnCellFocused(
                                rowIndex = index,
                                cellIndex = 0
                            )
                        )
                    }
                    .padding(vertical = 2.dp),
                style = MaterialTheme.typography.titleMedium
            )
        }
    }
}

@Composable
private fun BottomControls(
    onAction: (PyramidCrosswordAction) -> Unit,
) {
    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.Center,
        verticalAlignment = Alignment.CenterVertically
    ) {
        ItemButtonText(
            text = stringResource(SharedRes.strings.next_pyramid),
            onClick = { onAction(PyramidCrosswordAction.NextPyramid) },
            modifier = Modifier.padding(horizontal = 16.dp)
        )
    }
}

@Composable
private fun PyramidRow(
    rowIndex: Int,
    question: PyramidQuestion,
    userAnswer: String,
    isCorrect: Boolean?,
    isFocusedRow: Boolean,
    isGameFinished: Boolean,
    focusedCellIndex: Int,
    onAction: (PyramidCrosswordAction) -> Unit,
    onInvalidInput: () -> Unit,
) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.Center,
        modifier = Modifier.fillMaxWidth()
    ) {
        Text(
            text = "${rowIndex + 1}.",
            modifier = Modifier.width(30.dp),
            textAlign = TextAlign.End,
            style = MaterialTheme.typography.bodyLarge
        )

        Spacer(modifier = Modifier.width(8.dp))

        val numLetters = question.numberOfLettersInAnswer
        Row(horizontalArrangement = Arrangement.spacedBy(4.dp)) {
            for (cellIndex in 0 until numLetters) {
                PyramidCell(
                    char = userAnswer.getOrNull(cellIndex)?.toString().orEmpty(),
                    isFocused = isFocusedRow && cellIndex == focusedCellIndex,
                    isRowFocused = isFocusedRow,
                    isGameFinished = isGameFinished,
                    onInput = { onAction(PyramidCrosswordAction.OnCellInput(rowIndex, cellIndex, it)) },
                    onBackspace = { onAction(PyramidCrosswordAction.OnCellBackspace(rowIndex, cellIndex)) },
                    onFocus = { onAction(PyramidCrosswordAction.OnCellFocused(rowIndex, cellIndex)) },
                    onInvalidInput = onInvalidInput,
                )
            }
        }

        Spacer(modifier = Modifier.width(8.dp))

        StatusIcon(isCorrect)
    }
}

@Composable
private fun StatusIcon(isCorrect: Boolean?) {
    Box(
        modifier = Modifier.size(24.dp),
        contentAlignment = Alignment.Center
    ) {
        when (isCorrect) {
            true -> Image(
                painter = painterResource(imageResource = SharedRes.images.ic_answer_correct),
                contentDescription = "Correct answer"
            )

            false -> Image(
                painter = painterResource(imageResource = SharedRes.images.ic_answer_wrong),
                contentDescription = "Wrong answer"
            )

            null -> Unit
        }
    }
}

@Composable
private fun PyramidCell(
    char: String,
    isFocused: Boolean,
    isRowFocused: Boolean,
    isGameFinished: Boolean,
    onInput: (String) -> Unit,
    onBackspace: () -> Unit,
    onFocus: () -> Unit,
    onInvalidInput: () -> Unit,
) {
    val focusRequester = remember { FocusRequester() }
    val interactionSource = remember { MutableInteractionSource() }

    val displayChar = if (isPreview()) "א" else char

    var fieldValue by remember {
        androidx.compose.runtime.mutableStateOf(
            TextFieldValue(
                text = displayChar,
                selection = TextRange(displayChar.length),
            ),
        )
    }

    // Keep local fieldValue in sync with store + apply select-all when focused.
    LaunchedEffect(displayChar, isFocused) {
        fieldValue = TextFieldValue(
            text = displayChar,
            selection = if (isFocused) {
                TextRange(0, displayChar.length)
            } else {
                TextRange(displayChar.length)
            },
        )
    }

    // In a short window the keyboard would hide the pyramid before it was seen: it opens on a tap,
    // and from then on moves from cell to cell as usual.
    val isShortWindow = isShortWideWindow()
    val isKeyboardOpen = isKeyboardOpen()
    // Saved: a rotation must not bring back a keyboard the user has closed.
    var didRequestFocus by rememberSaveable(isFocused) { mutableStateOf(false) }
    LaunchedEffect(isFocused, isGameFinished) {
        if (isFocused && !isGameFinished && !didRequestFocus && (!isShortWindow || isKeyboardOpen)) {
            didRequestFocus = true
            focusRequester.requestFocus()
        }
    }

    val alpha = when {
        isFocused -> 0.5f
        isRowFocused -> 0.3f
        else -> 0.2f
    }

    val backgroundBrush = if (isFocused) {
        Brush.verticalGradient(
            colors = listOf(
                OrangeBottom.copy(alpha = alpha),
                OrangeBottom.copy(alpha = alpha),
            ),
        )
    } else {
        Brush.verticalGradient(
            colors = listOf(
                OrangeTop.copy(alpha = alpha),
                OrangeBottom.copy(alpha = alpha),
            ),
        )
    }

    BasicTextField(
        value = fieldValue,
        onValueChange = { newValue ->
            // Always update local value so selection/cursor stays responsive.
            fieldValue = newValue

            val newText = newValue.text

            // Ignore selection-only updates (common during focus/select-all).
            if (newText == displayChar) {
                return@BasicTextField
            }

            // Backspace / clear (text became empty).
            if (newText.isEmpty()) {
                onBackspace()
                return@BasicTextField
            }

            // Accept only a single Hebrew letter (א-ת).
            val lastChar = newText.last()
            if (lastChar in 'א'..'ת') {
                onInput(lastChar.toString())
            } else {
                onInvalidInput()

                // Revert local text to the current store char to avoid “ghost” chars.
                fieldValue = TextFieldValue(
                    text = displayChar,
                    selection = if (isFocused) {
                        TextRange(0, displayChar.length)
                    } else {
                        TextRange(displayChar.length)
                    },
                )
            }
        },
        modifier = Modifier
            .size(40.dp)
            .clip(RoundedCornerShape(3.dp))
            .background(backgroundBrush)
            .border(
                width = if (isFocused) 3.dp else 2.dp,
                color = if (isFocused) accentColor else StrokeColor,
                shape = RoundedCornerShape(3.dp),
            )
            .clickable(
                interactionSource = interactionSource,
                indication = null,
            ) {
                // Optimistic select-all immediately (UX feels instant).
                fieldValue = fieldValue.copy(
                    selection = TextRange(0, fieldValue.text.length),
                )

                if (isGameFinished) return@clickable

                // This updates the store focus.
                onFocus()
                focusRequester.requestFocus()
            }
            .onFocusChanged { state ->
                if (state.isFocused) {
                    // If this field actually gained focus, make store match reality.
                    if (state.isFocused && !isGameFinished && !isFocused) {
                        onFocus()
                    }

                    // Ensure select-all when focus comes from keyboard navigation, etc.
                    fieldValue = fieldValue.copy(
                        selection = TextRange(0, fieldValue.text.length),
                    )
                }
            }
            .onPreviewKeyEvent { event ->
                // Backspace may not change text when already empty, so onValueChange won't fire.
                if (
                    event.type == androidx.compose.ui.input.key.KeyEventType.KeyDown
                    && event.key == androidx.compose.ui.input.key.Key.Backspace
                ) {
                    onBackspace()
                    true
                } else {
                    false
                }
            }
            .focusRequester(focusRequester),
        textStyle = MaterialTheme.typography.bodyMedium.copy(
            color = Color.Black,
            fontSize = 20.sp,
            lineHeight = 20.sp,
            fontWeight = FontWeight.Bold,
            textAlign = TextAlign.Center,
        ),
        singleLine = true,
        keyboardOptions = KeyboardOptions(
            keyboardType = KeyboardType.Text,
            imeAction = ImeAction.Next,
        ),
        cursorBrush = SolidColor(accentColor),
        decorationBox = { innerTextField ->
            // Center the real text+cursor without adding a second Text composable.
            Box(
                modifier = Modifier.fillMaxSize(),
                contentAlignment = Alignment.Center,
            ) {
                innerTextField()
            }
        },
    )
}

private val OrangeTop = Color(0x0046FF6F)
private val OrangeBottom = Color(0x4D46FFB7)
private val StrokeColor = Color(0xFFDAA000)

@Preview
@Composable
private fun PreviewPyramidCrossword() {
    val jsonData = """
              [
                {
                  "number": "1",
                  "question": "מ-____ רוחות בואי הרוח (#)",
                  "answer": "ד"
                },
                {
                  "number": "2",
                  "question": "יעלה מן הארץ",
                  "answer": "אד"
                },
                {
                  "number": "3",
                  "question": "מבני בנימין",
                  "answer": "ארד"
                },
                {
                  "number": "4",
                  "question": "בני עם זה היו על חומות צור",
                  "answer": "ארוד"
                },
                {
                  "number": "5",
                  "question": "והקרבתיו ונגש אלי",
                  "answer": "אדירו"
                }
              ]
    """.trimIndent()

    val items: List<PyramidQuestion> = remember {
        jsonData.convertToDataClass<List<PyramidQuestion>>()
    }

    PreviewTheme {
        PyramidCrosswordContent(
            state = PyramidCrosswordState(
                currentQuestions = items.toImmutableList(),
                isLoading = false,
                isSkipReadMeChecked = false,
                isGameFinished = false,
                dialogState = DialogState.None,
            ),
            onAction = {},
            onInvalidInput = {},
        )
    }
}
